/* ag-p30-chrome: mobile polish lane script (2026-09-30, round 5). */
(function () {
  if (window.__agP30Chrome) return;
  window.__agP30Chrome = 1;

  var WA_LABEL = 'Chat with us on WhatsApp';
  var THEME_LIGHT = '#ffffff';
  var THEME_DARK = '#1b1e25';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /* ---- H1 FAB: accessible name only. Hide/overlap is CSS + layout. ------ */
  function enhanceFab(el) {
    if (!el || el.dataset.agChromeFab === '1') return;
    el.dataset.agChromeFab = '1';
    el.setAttribute('aria-label', WA_LABEL);
    if (!el.getAttribute('rel')) el.setAttribute('rel', 'noopener');
    var img = el.querySelector('img');
    if (img) {
      img.setAttribute('alt', '');
      img.setAttribute('aria-hidden', 'true');
    }
  }

  /* ---- H3 Header cart count: /cart.js or event payload only ------------- */
  var cartSeq = 0;
  var renderedCounts = new WeakMap();
  var lastCount = null;

  function headerCounts() {
    return Array.prototype.filter.call(document.querySelectorAll('.sf-header .sf-cart-count'), function (n) {
      return !n.closest('.ag-tabbar-shell');
    });
  }

  function readItemCount(obj) {
    if (!obj || typeof obj !== 'object' || obj.errors || obj.error) return null;
    if (!Object.prototype.hasOwnProperty.call(obj, 'item_count')) return null;
    var n = obj.item_count;
    if (typeof n !== 'number' || !Number.isInteger(n) || n < 0) return null;
    return n;
  }

  function applyCount(n) {
    if (typeof n !== 'number' || !Number.isInteger(n) || n < 0) return;
    lastCount = n;
    document.querySelectorAll('[data-ag-tabbar-cart]').forEach(function (link) {
      var badge = link.querySelector('.ag-tabbar__count');
      if (badge) {
        badge.textContent = n > 99 ? '99+' : String(n);
        badge.hidden = n === 0;
      }
      link.setAttribute('aria-label', 'Cart' + (n ? ', ' + n + ' item' + (n === 1 ? '' : 's') : ''));
    });
    headerCounts().forEach(function (el) {
      var label = n > 99 ? '99+' : String(n);
      renderedCounts.set(el, label);
      if (el.textContent !== label) el.textContent = label;
      if (n === 0) {
        el.setAttribute('hidden', '');
        el.setAttribute('aria-hidden', 'true');
      } else {
        el.removeAttribute('hidden');
        el.removeAttribute('aria-hidden');
      }
    });
  }

  function refreshCount() {
    if (!window.fetch) return;
    var seq = ++cartSeq;
    window.fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok || r.status < 200 || r.status >= 300) throw new Error('Cart response failed');
        return r.json();
      })
      .then(function (c) {
        if (seq !== cartSeq) return;
        var n = readItemCount(c);
        if (n === null) return;
        applyCount(n);
      })
      .catch(function () {});
  }

  function onCartEvent(e) {
    var d = e && e.detail;
    var n = readItemCount(d);
    if (n === null && d) n = readItemCount(d.cart);
    if (n !== null) {
      cartSeq += 1;
      applyCount(n);
      return;
    }
    refreshCount();
  }

  function isCartAjaxUrl(url) {
    return /\/cart\/(add|change|update|clear)\.js/.test(String(url || ''));
  }

  /* Minimog: app.js:20 exposes the bus; :1229 emits the cart payload;
     :3648-3650 subscribes and :3343-3344 writes raw badge text. */
  function reconcileNativeCounts() {
    headerCounts().forEach(function (el) {
      var text = el.textContent.trim();
      if (renderedCounts.get(el) === text) return;
      // Only native integer text is input. Our own '99+' label is never parsed.
      if (/^(0|[1-9]\d*)$/.test(text) && Number.isInteger(Number(text))) {
        cartSeq += 1;
        applyCount(Number(text));
      } else if (lastCount !== null) {
        applyCount(lastCount);
      }
    });
  }

  function bindCartBadge() {
    var countObserver = new MutationObserver(reconcileNativeCounts);
    function attachCounts() {
      countObserver.disconnect();
      headerCounts().forEach(function (el) {
        countObserver.observe(el, { childList: true, characterData: true, subtree: true });
      });
      reconcileNativeCounts();
    }
    attachCounts();
    // The stable Shopify header wrapper survives replacement of its contents.
    // Watch only header structure; unrelated body/app mutations never reach us.
    document.querySelectorAll('[id^="shopify-section-"]:has(.sf-header)').forEach(function (section) {
      new MutationObserver(function (records) {
        var changed = records.some(function (record) {
          return Array.prototype.some.call(record.addedNodes, function (node) {
            return node.nodeType === 1 && (node.matches('.sf-cart-count') || node.querySelector('.sf-cart-count'));
          }) || Array.prototype.some.call(record.removedNodes, function (node) {
            return node.nodeType === 1 && (node.matches('.sf-cart-count') || node.querySelector('.sf-cart-count'));
          });
        });
        if (changed) attachCounts();
      }).observe(section, { childList: true, subtree: true });
    });
    document.addEventListener('shopify:section:load', attachCounts);
    if (window.MinimogEvents && typeof window.MinimogEvents.subscribe === 'function') {
      window.MinimogEvents.subscribe('ON_CART_UPDATE', function (cart) {
        var n = readItemCount(cart);
        if (n === null) return;
        cartSeq += 1;
        applyCount(n);
      });
    }
    refreshCount();

    document.addEventListener('cart:updated', onCartEvent);
    document.addEventListener('cart:refresh', onCartEvent);
    document.addEventListener('cart:build', onCartEvent);

    window.addEventListener('pageshow', function (e) {
      if (e && e.persisted) refreshCount();
    });

    /* Mirror ag-tabbar-badge-sync-20260715: one follow-up /cart.js after
       add/change/update/clear — not a loop. Sequence number drops stale. */
    if (window.fetch && !window.fetch.__agChromeCart) {
      var orig = window.fetch;
      var wrapped = function () {
        var args = arguments;
        var p = orig.apply(this, args);
        try {
          var input = args[0];
          var url = String(input && input.url ? input.url : input || '');
          if (isCartAjaxUrl(url)) {
            p.then(function (r) {
              if (r.ok) window.setTimeout(refreshCount, 280);
            }).catch(function () {});
          }
        } catch (err) {}
        return p;
      };
      wrapped.__agChromeCart = true;
      window.fetch = wrapped;
    }
  }

  /* ---- H7 theme-color follows header surface, including opt-in dark ---- */
  function syncThemeColor() {
    var meta = document.querySelector('meta[name="theme-color"]');
    if (!meta) return;
    var dark = document.documentElement.getAttribute('data-ux-theme') === 'dark';
    var next = dark ? THEME_DARK : THEME_LIGHT;
    if (meta.getAttribute('content') !== next) meta.setAttribute('content', next);
  }
  function bindThemeColor() {
    syncThemeColor();
    try {
      new MutationObserver(syncThemeColor).observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['data-ux-theme']
      });
    } catch (e) {}
  }

  /* ---- H4 Announcement: first paint stays static; CSS delays rotate 5s.
     Do not reorder the DOM — chrome.css puts the last (COD) slide first
     with flex order so t=100ms is complete before this deferred file runs. */
  function initAnnouncement() {
    var root = document.querySelector('.announcement-content');
    if (!root || root.getAttribute('data-ag-ann') === '1') return;
    root.setAttribute('data-ag-ann', '1');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* v2 plan (2026-09-30): the bar is ONE static message carrying COD + prepaid — no rotation, so every visitor
       sees both facts and nothing paints mid-slide. */
    void reduce;
  }

  ready(function () {
    enhanceFab(document.getElementById('whatsapp-support'));
    bindCartBadge();
    bindThemeColor();
    initAnnouncement();
  });
})();
